import { createReducerContext } from '../../../../utils/create-reducer-context';
import { GovernmentProjectSearchState, GovernmentProjectSearchReducer, ACTION_TYPES } from './government-project-search-reducer';

const initialState: GovernmentProjectSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    drawer: { open: false },
};

const { Provider: GovernmentProjectSearchProvider, useStateContext: useGovernmentProjectSearchState, useDispatchContext: useGovernmentProjectSearchDispatch } = createReducerContext('GovernmentProjectSearch', GovernmentProjectSearchReducer, initialState);

export { GovernmentProjectSearchProvider, useGovernmentProjectSearchState, useGovernmentProjectSearchDispatch, ACTION_TYPES };
